import { getLocationMaindomain } from './getLocationSubdomain';

/** Domain of the public, hosted ModelPark service. */
export const DEFAULT_BRAND_DOMAIN = 'modelpark.app';

/**
 * Registrable domain this UI is served from, e.g. "modelpark.app" or
 * "example.com" for a self-hosted deployment.
 *
 * Falls back to the public domain when the host has no registrable domain
 * (localhost, bare IPs) so docs stay sensible during local development.
 */
export function getBrandDomain(): string {
    return getLocationMaindomain() || DEFAULT_BRAND_DOMAIN;
}

/** Base URL of this deployment, e.g. "https://example.com". */
export function getBrandBaseUrl(): string {
    return `https://${getBrandDomain()}`;
}

/** True when served from a domain other than the public ModelPark service. */
export function isSelfHosted(): boolean {
    return getBrandDomain() !== DEFAULT_BRAND_DOMAIN;
}

/**
 * Tunnel websocket endpoint for this deployment,
 * e.g. "wss://tunnel.example.com/ws".
 */
export function getBrandTunnelUrl(): string {
    return `wss://tunnel.${getBrandDomain()}/ws`;
}

/**
 * Host an app is published under, e.g. "myapp-proxy.example.com".
 * Tunnelled apps are served from the "-proxy" subdomain.
 */
export function getAppProxyHost(appName: string): string {
    return `${appName}-proxy.${getBrandDomain()}`;
}

/** Host of an app's UI page, e.g. "myapp.example.com". */
export function getAppHost(appName: string): string {
    return `${appName}.${getBrandDomain()}`;
}
